import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Menu,
  Home,
  User,
  LogOut,
  UserPen,
  Settings,
  ArrowRightFromLine,
  ArrowUpFromLine,
  ArrowLeftToLine,
  LayoutDashboard,
  Ticket,
  NotebookPenIcon,
  HardDriveUpload,
  BookOpenCheck
} from "lucide-react";
import profile from "../../Assets/Images/mithra.png";
import mithra from "../../Assets/Images/mithra-logo.png";
import mithrashort from "../../Assets/Images/mithra1.png";
import Switch from "./Switch";

const Sidebar = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [storeId, setStoreId] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [arrow, setArrow] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const formfilled = useSelector((state) => state.form.formfilled);
  const isSidebarShrunk = useSelector((state) => state.sidebar.isSidebarShrunk);
  console.log("Session Storage", sessionStorage.getItem("store_id"));
  console.log("Sidebar - Store ID TIME:", Date.now());

  const users = sessionStorage.getItem("first_name");

  const toggleShrink = () => {
    dispatch({ type: "TOGGLE_SIDEBAR" });
  };

  const logout = useCallback(() => {
    sessionStorage.clear();
    dispatch({ type: "SET_FORM_FILLED", payload: false });
    setTimeout(() => {
      window.catalyst.auth.signOut("/");
    }, 100);
  }, [dispatch]);

  const isActive = (path) => {
    const currentPath = location.pathname;
    return (
      currentPath === path ||
      (path === "/project" && currentPath === "/milestone") ||
      (path === "/enquiry" && currentPath === "/enquiry/viewEnquiry") ||
      (path === "/BundlePage" && currentPath === "/ViewPlans")
    );
  };

  const store_id = sessionStorage.getItem("store_id")
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
    if (window.innerWidth >= 768) {
      setMobileOpen(false);
    }
  };


  

  useEffect(() => {

      const initializeUserInfo = () => {
      const storedStoreId = sessionStorage.getItem("store_id");
      
      if (storedStoreId) {
        setStoreId(storedStoreId);
        console.log("Store ID loaded in header:", storedStoreId);
      } else {
        // If not found immediately, check again after a short delay
        console.log("Store ID not found, retrying...", Date.now());
        setTimeout(() => {
          const delayedStoreId = sessionStorage.getItem("store_id");
          if (delayedStoreId) {
            setStoreId(delayedStoreId);
            console.log("Store ID loaded in header (delayed):", delayedStoreId);
          }
          console.log("Store ID still not found after delay.", Date.now());
        }, 3000);
      }
    };
    
    initializeUserInfo();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
    if (isMobile) {
      setMobileOpen(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 bottom-0 flex flex-col shadow-lg bg-white transition-all duration-300 ease-in-out z-50 
        ${isMobile ? (mobileOpen ? "translate-x-0" : "-translate-x-full") : ""} 
        ${isMobile ? "w-[250px]" : isSidebarShrunk ? "w-[90px]" : "w-[250px]"}`}
      >
        {/* Sidebar Header */}
        <div className="p-4 flex items-center justify-between bg-white shadow-lg h-[73px]">
          <div className="flex items-center">
            {isSidebarShrunk && !isMobile ? (
              <img src={mithrashort} alt="Logo" className="h-15 w-full transition-all duration-300" />
            ) : (
              <img src={mithra} alt="Logo" className="h-20 w-full transition-all duration-300 p-2" />
            )}
          </div>
        </div>

        {/* Sidebar Links */}
        <ul className="mt-4 flex-grow pr-3 pl-2">
          {[{ path: "/home", label: "Home", icon: <Home size={25} /> },
          // { path: "/ticket", label: "Ticket Forms", icon: <NotebookPenIcon size={25} /> },
          { path: "/dash", label: "Dashboard", icon: <LayoutDashboard size={25} /> },
          // { path: "/ticketdetails", label: "Tickets", icon: <Ticket size={25} /> },
          // { path: "/uploadbill", label: "Upload Bill", icon: <HardDriveUpload size={25} /> },
          // { path: "/profile", label: "Buttons", icon: <User size={24} /> },
          { path: "/reportform", label: "Report Form", icon: <NotebookPenIcon size={25} /> },
            //  { path: "/report", label: "Report", icon:  <BookOpenCheck   size={25}/> },
          ].map(({ path, label, icon }) => {
            // If form not filled and path is not home, disable link and blur it
            const disabled = !formfilled && path !== "/home";

            return (
              <li
                key={path}
                className={`flex items-center py-3 cursor-pointer mt-2 rounded-lg font-Jost text-[18px] transition-all px-4 
          ${isActive(path) ? "bg-gradient-to-r from-[#D15D69] via-[#eda06d] to-[#E78962] text-white" : "hover:bg-gray-200 text-black"} 
          ${isSidebarShrunk && !isMobile ? "justify-center" : "px-6"}
          ${disabled ? "pointer-events-none opacity-50 select-none" : ""} 
        `}
                onClick={() => !disabled && handleNavigate(path)}
              >
                {icon}
                {(!isSidebarShrunk || isMobile) && <span className="ml-3 text-lg">{label}</span>}
              </li>
            );
          })}
        </ul>


        {/* Profile Dropdown */}
        <div className="relative">
          <div
            className="flex items-center py-3 px-6 cursor-pointer border-t border-gray-300 hover:bg-gray-200 transition-all"
            onClick={() => {
              setShowDropdown(!showDropdown);
              setArrow(!arrow);
            }}
          >
            <img
              src={profile}
              alt="Profile"
              className="w-10 h-10 rounded-full border border-gray-400"
            />
            {(!isSidebarShrunk || isMobile) && <span className="ml-3 text-[18px] font-Jost truncate">{users}</span>}
            {!showDropdown ? <ArrowRightFromLine className="ml-auto" /> : <ArrowUpFromLine className="ml-auto" />}
          </div>

          {showDropdown && (
            <div className="absolute bottom-full left-0 mb-2 w-full bg-white border border-gray-300 shadow-lg rounded-md z-50">
              <ul className="py-2">
                {/* <li
                  className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleNavigate("/profilepage")}
                >
                  <UserPen className="mr-3" size={20} />
                  Profile
                </li> */}
                {/* <li className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer">
                  <Settings className="mr-3" size={20} />
                  Settings
                </li> */}
                <li
                  className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer"
                  onClick={logout}
                >
                  <LogOut className="mr-3" size={20} />
                  Logout
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* Main Content */}
      <div
        className={`flex-grow transition-all duration-300 ${isMobile ? (mobileOpen ? "ml-[250px]" : "ml-0") : isSidebarShrunk ? "ml-[90px]" : "ml-[250px]"
          }`}
      >
        {/* Navbar */}
        <div
          className={`fixed top-0 left-0 right-0 h-[73px] flex justify-between items-center px-4 bg-white shadow-lg z-40 ${isMobile ? "" : isSidebarShrunk ? "ml-[90px]" : "ml-[250px]"
            }`}
        >
          <div className="flex items-center">
            <button
              onClick={() => {
                if (isMobile) {
                  setMobileOpen(true);
                } else {
                  toggleShrink();
                }
              }}
              className="text-black text-xl flex"
            >
              <Menu className="text-md me-2" />
            </button>

            <span className="font-medium text-[20px] text-black-800 ml-3">
              👋 Welcome {users}
            </span>
          </div>

          <div>


            <span className="font-medium text-md text-white ml-3 bg-[#E57320] p-2 rounded-lg">  Store ID:  {storeId} </span>

          </div>
        </div>

        {/* Page Content */}
        <div className="pt-20 bg-[#F7F7F7] min-h-screen px-4">{children}</div>
      </div>
    </div>
  );
};

export default Sidebar;
